module.exports = __webpack_public_path__ + "static/media/exterior door 2.ff8a8052.jpg";